import React, { Dispatch } from "react";
import { ActionType } from "../../Actions";
import { DispatchContext } from "../../UserContext";


export function useDispatch() : Dispatch<ActionType> {
    const context = React.useContext(DispatchContext);
	if (context === undefined) {
		throw new Error('useAuthDispatch must be used within a AuthProvider');
	}

	return context;
}